import { useQuery } from '@tanstack/react-query';
import { getIntellisenseData } from 'Services';
import { RQ_GET_INTELLISENSE_DATA } from 'Utils';

const useGetIntellisenseData = () => {
    return useQuery([RQ_GET_INTELLISENSE_DATA], () => getIntellisenseData());
};

export default useGetIntellisenseData;
